import { FlowTypes } from "@trailhead/smart-setup-core";
import { FactoryTypes, FieldID } from "../../../models";

const getTipBoxFieldsForReplacement = (
  flowType: FlowTypes,
  subStep = false,
  heading2 = false,
) => {
  if (flowType === FlowTypes.Replacement) {
    return {
      type: FactoryTypes.TIPBOX,
      fieldMapping: {
        text: FieldID.guideContainer.tipBox.iPhone14SetupBeforeYouStartActivate,
        icon: FieldID.guideContainer.tipBox.iPhone14SetupTipBoxDefaultImage,
        heading: heading2
          ? FieldID.guideContainer.tipBox
            .iPhone14SetupBeforeYouStartActivateHeading2
          : FieldID.guideContainer.tipBox.iPhone14SetupBeforeYouStartActivate,
        buttonText:
          FieldID.guideContainer.tipBox.iPhone14SetupBeforeYouStartActivate,
        buttonURL:
          FieldID.guideContainer.tipBox.iPhone14SetupBeforeYouStartActivate,
        subStep,
      },
    };
  }

  return undefined;
};

const getiCloudBackupSteps = (flowType: FlowTypes) =>
  [
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupRestoreFromiCloud.text,
        image:
          FieldID.guideContainer.steps.iPhone14SetupRestoreFromiCloud.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupiCloudAppleID.text,
        image: FieldID.guideContainer.steps.iPhone14SetupiCloudAppleID.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupVerificationCode.text,
        substep:
          FieldID.guideContainer.steps.iPhone14SetupVerificationCode.substep,
        image: FieldID.guideContainer.steps.iPhone14SetupVerificationCode.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupTermsAndConditions.text,
        substep:
          FieldID.guideContainer.steps.iPhone14SetupTermsAndConditions.substep,
        image:
          FieldID.guideContainer.steps.iPhone14SetupTermsAndConditions.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupMakeThis.text,
        image: FieldID.guideContainer.steps.iPhone14SetupMakeThis.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupPrompts.text,
        substep: FieldID.guideContainer.steps.iPhone14SetupFollowPrompts.text,
        image: FieldID.guideContainer.steps.iPhone14SetupPromptsCellular.image,
      },
    },
    getTipBoxFieldsForReplacement(flowType),
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupSiri.text,
        substep: FieldID.guideContainer.steps.iPhone14SetupSiri.substep,
        image: FieldID.guideContainer.steps.iPhone14SetupSiri.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupComplete.text,
        substep:
          FieldID.guideContainer.steps.iPhone14SetupDownloadInBackground.text,
        image: FieldID.guideContainer.steps.iPhone14SetupComplete.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupCellular.text,
      },
    },
    {
      type: FactoryTypes.SUB_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupIfUnavailable.text,
      },
    },
    {
      type: FactoryTypes.IMAGE,
      fieldMapping: {
        image: FieldID.guideContainer.steps.iPhone14SetupCellular.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupCompleteTestCall.text,
      },
    },
  ].filter(field => typeof field !== "undefined");

const getDontTransferSteps = (flowType: FlowTypes) =>
  [
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupDontTransfer.text,
        image: FieldID.guideContainer.steps.iPhone14SetupDontTransfer.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupAppleID.text,
        image: FieldID.guideContainer.steps.iPhone14SetupAppleID.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupVerificationCode.text,
        substep:
          FieldID.guideContainer.steps.iPhone14SetupVerificationCode.substep,
        image: FieldID.guideContainer.steps.iPhone14SetupVerificationCode.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupTermsContinue.text,
        image: FieldID.guideContainer.steps.iPhone14SetupTermsContinue.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupEnableiMessage.text,
        image: FieldID.guideContainer.steps.iPhone14SetupEnableiMessage.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupEnableLocation.text,
        image: FieldID.guideContainer.steps.iPhone14SetupEnableLocation.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupPrompts.text,
        substep: FieldID.guideContainer.steps.iPhone14SetupFollowPrompts.text,
        image: FieldID.guideContainer.steps.iPhone14SetupPromptsCellular.image,
      },
    },
    getTipBoxFieldsForReplacement(flowType),
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupContinueToSiri.text,
        image: FieldID.guideContainer.steps.iPhone14SetupContinueToSiri.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupScreentime.text,
        image: FieldID.guideContainer.steps.iPhone14SetupScreentime.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupShareAnalytics.text,
        substep:
          FieldID.guideContainer.steps.iPhone14SetupShareAnalytics.substep,
        image: FieldID.guideContainer.steps.iPhone14SetupShareAnalytics.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupAppearance.text,
        image: FieldID.guideContainer.steps.iPhone14SetupAppearance.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupZoomedDisplay.text,
        image: FieldID.guideContainer.steps.iPhone14SetupZoomedDisplay.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupSOS.text,
        image: FieldID.guideContainer.steps.iPhone14SetupSOS.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupWelcomeScreen.text,
        image: FieldID.guideContainer.steps.iPhone14SetupWelcomeScreen.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupCellular.text,
      },
    },
    {
      type: FactoryTypes.SUB_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupIfUnavailable.text,
      },
    },
    {
      type: FactoryTypes.IMAGE,
      fieldMapping: {
        image: FieldID.guideContainer.steps.iPhone14SetupCellular.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.iPhone14SetupCompleteTestCall.text,
      },
    },
  ].filter(field => typeof field !== "undefined");

export const iphone14SetupContentWithPhone = (flowType: FlowTypes) =>
  [
    {
      type: FactoryTypes.DECISION_STEP,
      fieldMapping: {
        questionText:
          FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
        yesSteps: [
          getTipBoxFieldsForReplacement(flowType, false, true),
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupCellular.text,
            },
          },
          {
            type: FactoryTypes.SUB_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupIfUnavailable
                .text,
            },
          },
          {
            type: FactoryTypes.IMAGE,
            fieldMapping: {
              image: FieldID.guideContainer.steps.iPhone14SetupCellular.image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupCompleteTestCall
                .text,
            },
          },
          {
            type: FactoryTypes.EXPERT_HELP,
            fieldMapping: {
              buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
              title: FieldID.guideContainer.expertHelpContent.title,
              subtext: FieldID.guideContainer.expertHelpContent.subtext,
              secondaryButtonText:
                FieldID.guideContainer.expertHelpContent.secondaryButtonText,
              supportNumber:
                FieldID.guideContainer.expertHelpContent.supportNumber,
              icon: FieldID.guideContainer.expertHelpContent.icon,
            },
          },
        ].filter(config => typeof config !== "undefined"),
        noSteps: [
          {
            type: FactoryTypes.TIPBOX,
            fieldMapping: {
              text: FieldID.guideContainer.tipBox
                .iPhone14SetupBeforeYouStartWifi,
              icon: FieldID.guideContainer.tipBox
                .iPhone14SetupTipBoxDefaultImage,
              heading:
                FieldID.guideContainer.tipBox.iPhone14SetupBeforeYouStartWifi,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupQuickStartImage
                .text,
              image:
                FieldID.guideContainer.steps.iPhone14SetupQuickStartImage.image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupUnlock.text,
            },
          },
          {
            type: FactoryTypes.SUB_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupUnableToUseDevice
                .text,
            },
          },
          {
            type: FactoryTypes.IMAGE,
            fieldMapping: {
              image: FieldID.guideContainer.steps.iPhone14SetupUnlock.image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupCamera.text,
              image: FieldID.guideContainer.steps.iPhone14SetupCamera.image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupForMe.text,
              image: FieldID.guideContainer.steps.iPhone14SetupForMe.image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupPasscodeOtherPhone
                .text,
              image:
                FieldID.guideContainer.steps.iPhone14SetupPasscodeOtherPhone
                  .image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupPrompts.text,
            },
          },
          {
            type: FactoryTypes.SUB_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupFollowPrompts
                .text,
            },
          },
          {
            type: FactoryTypes.IMAGE,
            fieldMapping: {
              image: FieldID.guideContainer.steps.iPhone14SetupPrompts.image,
            },
          },
          getTipBoxFieldsForReplacement(flowType, true),
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupTransferData.text,
            },
          },
          {
            type: FactoryTypes.SUB_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupPrepareMove.text,
            },
          },
          {
            type: FactoryTypes.IMAGE,
            fieldMapping: {
              image:
                FieldID.guideContainer.steps.iPhone14SetupTransferData.image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupMakeThisYourPhone
                .text,
              image:
                FieldID.guideContainer.steps.iPhone14SetupMakeThisYourPhone
                  .image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupSiri.text,
            },
          },
          {
            type: FactoryTypes.SUB_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupConnectedToPower
                .text,
            },
          },
          {
            type: FactoryTypes.IMAGE,
            fieldMapping: {
              image:
                FieldID.guideContainer.steps.iPhone14SetupTransferringData
                  .image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupComplete.text,
            },
          },
          {
            type: FactoryTypes.SUB_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps
                .iPhone14SetupDownloadInBackground.text,
            },
          },
          {
            type: FactoryTypes.IMAGE,
            fieldMapping: {
              image: FieldID.guideContainer.steps.iPhone14SetupComplete.image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupCellular.text,
            },
          },
          {
            type: FactoryTypes.SUB_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupIfUnavailable
                .text,
            },
          },
          {
            type: FactoryTypes.IMAGE,
            fieldMapping: {
              image: FieldID.guideContainer.steps.iPhone14SetupCellular.image,
            },
          },
          {
            type: FactoryTypes.NUMBERED_STEP,
            fieldMapping: {
              text: FieldID.guideContainer.steps.iPhone14SetupCompleteTestCall
                .text,
            },
          },
          {
            type: FactoryTypes.EXPERT_HELP,
            fieldMapping: {
              buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
              title: FieldID.guideContainer.expertHelpContent.title,
              subtext: FieldID.guideContainer.expertHelpContent.subtext,
              secondaryButtonText:
                FieldID.guideContainer.expertHelpContent.secondaryButtonText,
              supportNumber:
                FieldID.guideContainer.expertHelpContent.supportNumber,
              icon: FieldID.guideContainer.expertHelpContent.icon,
            },
          },
        ].filter(field => typeof field !== "undefined"),
      },
    },
  ].filter(field => typeof field !== "undefined");

export const iphone14SetupContentLostPhone = (flowType: FlowTypes) => [
  {
    type: FactoryTypes.DECISION_STEP,
    fieldMapping: {
      questionText:
        FieldID.guideContainer.decisionStep.haveYouWalkedThroughSetupSteps,
      yesSteps: [
        getTipBoxFieldsForReplacement(flowType, false, true),
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iPhone14SetupCellular.text,
          },
        },
        {
          type: FactoryTypes.SUB_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iPhone14SetupIfUnavailable.text,
          },
        },
        {
          type: FactoryTypes.IMAGE,
          fieldMapping: {
            image: FieldID.guideContainer.steps.iPhone14SetupCellular.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iPhone14SetupCompleteTestCall
              .text,
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ].filter(config => typeof config !== "undefined"),
      noSteps: [
        {
          type: FactoryTypes.TIPBOX,
          fieldMapping: {
            text: FieldID.guideContainer.tipBox.iPhone14SetupNewPhoneNearby,
            icon: FieldID.guideContainer.tipBox.iPhone14SetupTipBoxDefaultImage,
            heading:
              FieldID.guideContainer.tipBox.iPhone14SetupBeforeYouStartWifi,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iPhone14SetupTurnOnDeviceManual
              .text,
            image:
              FieldID.guideContainer.steps.iPhone14SetupTurnOnDeviceManual
                .image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iPhone14SetupWifiSelect.text,
            image: FieldID.guideContainer.steps.iPhone14SetupWifiSelect.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iPhone14SetupPrivacy.text,
            image: FieldID.guideContainer.steps.iPhone14SetupPrivacy.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iPhone14SetupFaceID.text,
            image: FieldID.guideContainer.steps.iPhone14SetupFaceID.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps.iPhone14SetupPasscode.text,
            image: FieldID.guideContainer.steps.iPhone14SetupPasscode.image,
          },
        },
        {
          type: FactoryTypes.NUMBERED_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps
              .iPhone14SetupChooseHowToTransferData.text,
          },
        },
        {
          type: FactoryTypes.SUB_STEP,
          fieldMapping: {
            text: FieldID.guideContainer.steps
              .iPhone14SetupChooseHowToTransferData.substep,
          },
        },
        {
          type: FactoryTypes.IMAGE,
          fieldMapping: {
            image:
              FieldID.guideContainer.steps.iPhone14SetupChooseHowToTransferData
                .image,
          },
        },
        {
          type: FactoryTypes.DECISION_STEP,
          fieldMapping: {
            questionText:
              FieldID.guideContainer.steps.iPhone14SetupShowInstructionsFor
                .text,
            decisionOptions: [
              {
                display: "Restore from iCloud Backup",
                steps: getiCloudBackupSteps(flowType),
              },
              {
                display: "Don't Transfer Apps & Data",
                steps: getDontTransferSteps(flowType),
              },
            ],
          },
        },
        {
          type: FactoryTypes.EXPERT_HELP,
          fieldMapping: {
            buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
            title: FieldID.guideContainer.expertHelpContent.title,
            subtext: FieldID.guideContainer.expertHelpContent.subtext,
            secondaryButtonText:
              FieldID.guideContainer.expertHelpContent.secondaryButtonText,
            supportNumber:
              FieldID.guideContainer.expertHelpContent.supportNumber,
            icon: FieldID.guideContainer.expertHelpContent.icon,
          },
        },
      ].filter(field => typeof field !== "undefined"),
    },
  },
];
